/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_service_alertnow': {
    width: 23,
    height: 19,
    viewBox: '0 0 23 19',
    data: '<defs><path pid="0" d="M17.966 8.48h.029v5.983h-.022l.021.021-2.827 2.82-2.121-2.115 1.95-1.944V9.748l-1.95-1.944 2.12-2.115 2.8 2.792zm4.998-2.99h.03v.028l.006.007-.007.007v11.922h-.014l.021.021L19.465 21l-2.12-2.115 2.649-2.642V6.757l-2.65-2.642L19.466 2l3.5 3.49zM5.02 14.463h-.022V8.48h.029l2.8-2.792 2.12 2.115-1.95 1.944v3.497l1.95 1.944-2.12 2.115-2.829-2.82.022-.021zM.02 17.453H0V5.49h.036L3.535 2l2.12 2.115L3 6.764v9.472l2.656 2.649L3.535 21 0 17.475l.021-.021zM11.497 13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" id="svgicon_icon_service_alertnow_a"/></defs><g transform="translate(0 -2)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_service_alertnow_b" _fill="#fff"><use xlink:href="#svgicon_icon_service_alertnow_a"/></mask><use _fill="#000" xlink:href="#svgicon_icon_service_alertnow_a"/><g mask="url(#svgicon_icon_service_alertnow_b)" _fill="#FF7B49"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_service_alertnow.js